var map = {
	"./private-cn.png": "kqiY",
	"./private-en.png": "rVwN",
	"./private-th.png": "sofu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "icK0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copyright/private ^\.\/private\-.*\.png$
// module id = icK0
// module chunks = 1